import { ModalDialog } from './dumb.js';
import enhance from './enhancer';

export default enhance(ModalDialog);
